export const EMOJI_COUNT = 10;

export const EMOJI_LIFETIME_MS = 3000;

export const EMOJI_SIZE = 45;
export const EMOJI_OFFSET_Y = 55;

export const EMOJI_BAR_ICON = 5;
export const EMOJI_BAR_BUTTON_SIZE = 40;

export interface ActiveEmoji {
  readonly entityId: number | null;
  readonly index: number;
  readonly at: number;
}

export interface Rect {
  readonly x: number;
  readonly y: number;
  readonly w: number;
  readonly h: number;
}

export function emojiBarButton(uiWidth: number, uiHeight: number): Rect {
  return {
    x: uiWidth / 5,
    y: uiHeight - EMOJI_BAR_BUTTON_SIZE,
    w: EMOJI_BAR_BUTTON_SIZE,
    h: EMOJI_BAR_BUTTON_SIZE,
  };
}

/** Slots run in key order (1-9 then 0), matching a keyboard's number row rather than sprite order. */
export function emojiBarSlots(
  uiWidth: number,
  uiHeight: number,
): readonly (Rect & { index: number })[] {
  const increment = uiWidth / 40;
  const anchorX = uiWidth / 5;
  const y = uiHeight - EMOJI_BAR_BUTTON_SIZE * 2;
  const slots: (Rect & { index: number })[] = [];
  for (let i = 1; i <= EMOJI_COUNT; i++) {
    slots.push({
      index: i % EMOJI_COUNT,
      x: anchorX - (increment * 11) / 2 + increment * i,
      y,
      w: increment,
      h: increment,
    });
  }
  return slots;
}

export function hitTest(rect: Rect, x: number, y: number): boolean {
  return x >= rect.x && x <= rect.x + rect.w && y >= rect.y && y <= rect.y + rect.h;
}

export class EmojiField {
  private readonly live: ActiveEmoji[] = [];

  get all(): readonly ActiveEmoji[] {
    return this.live;
  }

  get count(): number {
    return this.live.length;
  }

  add(entityId: number | null, index: number, now: number): void {
    if (!Number.isInteger(index) || index < 0 || index >= EMOJI_COUNT) return;
    this.live.push({ entityId, index, at: now });
  }

  advance(now: number): void {
    let write = 0;
    for (const emoji of this.live) {
      if (now > emoji.at + EMOJI_LIFETIME_MS) continue;
      this.live[write++] = emoji;
    }
    this.live.length = write;
  }

  clear(): void {
    this.live.length = 0;
  }
}
